import { action, computed, makeAutoObservable } from "mobx";
import { RoundRef } from "../types";

export interface RoundEntry {
  name: string;
  active: boolean;
  vote: boolean;
  end_time: string;
  n_votes?: number;
  n_winners?: number;
  title?: string;
}

export class RoundStore {
  private data = new Array<RoundEntry>();

  constructor() {
    makeAutoObservable(this);
  }

  @action
  update(items: RoundRef[]) {
    this.data.length = 0;
    for (const item of items) {
      this.data.push(item);
    }
  }

  @computed
  list() {
    return [...this.data];
  }

  @computed
  get(): RoundEntry[] {
    return this.data;
  }

  @computed
  getActiveRound(): string {
    for (const item of this.data) {
      if (item.active) {
        return item.name;
      }
    }
    return "";
  }

  @computed
  getVotingRounds(): RoundEntry[] {
    return this.data.filter((r) => r.vote);
  }

  @computed
  isAuctionPhase(): boolean {
    return this.data.find((item) => item.active)?.name === "auction" ?? false;
  }

  @computed
  isDonePhase(): boolean {
    return this.data.find((item) => item.active)?.name === "done" ?? false;
  }

  @computed
  isVotePhase(): boolean {
    return !!this.data.find((item) => item.active && item.vote);
  }

  @computed
  getPhaseEndTime(name: string): Date | undefined {
    const endTime = this.data.find((item) => item.name === name)?.end_time;
    if (endTime) {
      return new Date(endTime);
    }
  }

  @computed
  isBuildPhase(): boolean {
    return this.data.find((item) => item.active)?.name === "entropy" ?? false;
  }

  @computed
  getActiveVoteRoundOrLatest() {
    let active = this.data.find((item) => item.active && item.vote);
    if (active !== undefined) {
      return active;
    }
    const now = Date.now();
    for (let i = this.data.length - 1; i >= 0; --i) {
      const time = Date.parse(this.data[i].end_time);
      if (this.data[i].vote && time <= now) {
        return this.data[i];
      }
    }
    let first = this.data.find((item) => item.vote);
    if (first !== undefined) {
      return first;
    }
  }
}
